module.exports = __webpack_public_path__ + "img/changeStonegroup-1@2x.ceab006.webp";